import * as React from 'react';
import Modal from './Modal';
import Select from 'react-select';
import Button from './Button';
import IconAdd from './IconAdd';
import IconEdit from './IconEdit';
import Common from '../util/common';
import styled from 'styled-components';
class WelcomeModal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            listId: undefined,
            showNewListForm: false,
            showLoadListForm: false
        };
        this.setListId = (event) => {
            console.log("set listId");
            this.setState({ listId: event.currentTarget.value });
        };
        this.loadList = (listId) => {
            const loadListId = listId ? listId : this.state.listId;
            this.props.handlers.loadList(loadListId);
        };
        this.showOptionsHandler = () => {
            this.setState({
                showNewListForm: false,
                showLoadListForm: false
            });
        };
        this.newListHandler = () => {
            console.log("newListHandler");
            this.setState({
                showNewListForm: true,
                showLoadListForm: false
            });
        };
        this.loadListHandler = () => {
            console.log("loadListHandler");
            this.setState({
                showNewListForm: false,
                showLoadListForm: true
            });
        };
    }
    render() {
        console.log("render WelcomeModal");
        const common = new Common();
        const title = "Draft Assist";
        const buttons = (React.createElement(React.Fragment, null,
            React.createElement(Button, { label: "Back", clicked: this.showOptionsHandler }),
            React.createElement(Button, { label: "Continue", clicked: () => { this.loadList(); } })));
        const handlers = {
            closeModal: this.props.handlers.closeWelcomeModal
        };
        const newListComponent = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, "Give your list a name. All changes will be automatically saved under this name."),
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "New List Name"),
                            React.createElement("td", null,
                                React.createElement("input", { id: "newListId", type: "text", onChange: this.setListId }))))),
                buttons));
        };
        const loadListComponent = () => {
            return (React.createElement(React.Fragment, null,
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "Choose List"),
                            React.createElement("td", null,
                                React.createElement(Select, { onChange: (data) => { this.loadList(data.value); }, isSearchable: false, styles: common.selectStyles(), isMulti: false, options: common.listsForSelect() }))))),
                buttons));
        };
        const chooseOptionComponent = () => {
            return (React.createElement("div", { className: 'options' },
                React.createElement(IconAdd, { className: "button newList", width: "150px", height: "150px", clicked: this.newListHandler },
                    React.createElement("p", null, "New List")),
                React.createElement(IconEdit, { className: "button loadList", width: "150px", height: "150px", clicked: this.loadListHandler },
                    React.createElement("p", null, "Load List"))));
        };
        const form = this.state.showNewListForm
            ? newListComponent()
            : this.state.showLoadListForm
                ? loadListComponent()
                : chooseOptionComponent();
        return (React.createElement(Modal, { title: title, show: true, handlers: handlers },
            React.createElement(ModalStyle, null, form)));
    }
}
;
export default WelcomeModal;
const ModalStyle = styled.div `
  .options {
    margin: 0 auto;
    text-align: center;
  }

  table {
    border-spacing: 0 20px;
    width: 100%;
  }

  table td:first-child {
    width: 200px;
  }

  table input {
    border: 1px solid white;
    font-size: 1.3em;
    padding: 5px;
  }

  svg {
    cursor: pointer;
    fill: #999;
  }

  .button {
    display: inline-block;
    margin: 0 25px;
  }
`;
//# sourceMappingURL=WelcomeModal.js.map


// WEBPACK FOOTER //
// ./src/components/WelcomeModal.js